import { SystemClaimPermission } from 'src/types/claims';

export interface LoginResponse {
  authorization: string;
  user: IUser;
  succeeded: boolean;
}

export interface OpenIdResponse {
  access_token: string;
  refresh_token: string;
  id_token?: string;
  expires_in: number;
  token_type: string;
}

export interface IUser {
  userName: string;
  name: string;
  email: string;
  profileName: string;
  claims: SystemClaimPermission;
  rut: string;
  rol: number;
}

export const DefaultIUser = {
  userName: '',
  name: '',
  email: '',
  profileName: '',
  claims: {} as SystemClaimPermission,
  rut: '',
  rol: 0,
};

export interface IdentityClaims {
  userName: string;
  name: string;
  picture: string;
  position: string;
  email: string;
  rut: string;
  rol: string;
}

export interface Token {
  token: string;
  expires: Date;
}

export interface IdentityResponse {
  identity: IdentityClaims;
  expired: Date;
}
